// extracted by css-extract-rspack-plugin
export default {"tableWrapper":"S_uoZ","checked":"_7WsNA","isSelected":"_3Nq2J"};